import { render, staticRenderFns } from "./BankPicker.vue?vue&type=template&id=584b57d7&scoped=true&"
import script from "./BankPicker.vue?vue&type=script&lang=js&"
export * from "./BankPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584b57d7",
  null
  
)

export default component.exports